const configuredBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();

if (!configuredBaseUrl && !import.meta.env.DEV) {
  throw new Error('VITE_API_BASE_URL must be configured for production builds.');
}

export const guestApiBaseUrl = configuredBaseUrl ?? 'http://localhost:5091';

/** Bildadressen des Servers sind relativ; fertige Adressen (Bühne, Blob) bleiben, wie sie sind. */
export function guestAssetUrl(url: string): string {
  return /^(https?|data|blob):/.test(url) ? url : `${guestApiBaseUrl}${url}`;
}
